module.exports = __webpack_public_path__ + "img/gr.ffa12c3c.png";